import makeStyles from '@mui/styles/makeStyles';
import {dynamicWidth} from '../forms/formsUtil';

export const useMainScreenStyles = makeStyles((theme) => {
    return {
        secondary: {
            light: '#b2b2b2',
            main: '#b2b2b2',
            dark: '#b2b2b2',
            contrastText: '#000000',
        },
        //
        noteSpacing: {
            marginBottom: 20,
        },
        cellReadOnlyElement: {
            padding: 8,
            userSelect: 'none',
            minHeight: 217,
            borderRadius: 8,
            boxShadow: `0px ${theme.palette.mode === 'light' ? 4 : 0}px ${theme.palette.mode === 'light' ? 4 : 0}px 0px rgba(0, 0, 0, 0.25)`,
        },
        timerDynamic: {
            '& .timer-count-up': {
                userSelect: 'none',
                padding: '2px 16px',
                borderRadius: 5,
                fontWeight: 'bold',
                fontSize: '120%',
                height: 35,
                textAlign: 'center',
            },
        },
        cellReadOnlyLabel: {
            textTransform: 'uppercase',
            fontSize: '90%',
            opacity: 0.7,
            '&.hour': {
                fontSize: '14px',
                display: 'inline',
                marginRight: 10,
            },
        },
        cellReadOnlyValue: {
            fontWeight: 'bold',
            fontSize: 12,
        },
        cellReadOnlyLabelIP: {
            fontWeight: 700,
            fontSize: 14,
            paddingBottom: 5,

            '&.hour': {
                fontSize: '14px',
                display: 'inline',
                marginRight: 10,
            },
        },
        timeSize: {
            fontSize: '22px',
        },
        autocompleteBox: {},
        singleGridDisplayItemParent: {
            position: 'relative',
            '&.big-row': {},
        },
        paperDarker: {
            backgroundColor: theme.palette.background.paperDarker,
        },
        singleGridDisplayItem: {},
        seenDlg: {
            '& .label-set': {
                textTransform: 'none !important',
                paddingBottom: 0,
                '& .label-part1': {
                    textTransform: 'uppercase',
                },
                '& .label-part2': {
                    // fontWeight: "normal"
                    fontWeight: 'normal',
                    // marginTop: "10px",
                    wordBreak: 'break-word',
                },
                '& .label-part3': {
                    fontSize: '90%',
                    opacity: 0.7,
                    whiteSpace: 'break-spaces',
                },
            },
            '& .not-set': {},
            '& .not-set-not-mandatory': {},
        },
        //
        patientHeaderItem: {
            fontSize: 14,
            verticalAlign: 'top',
            lineHeight: '24px',
            display: 'inline-block',
            margin: '0 5px',
            backgroundColor: theme.palette.background.paper,
            padding: '2px 7px',
            borderRadius: 5,
            '& .label': {
                marginRight: 5,
                fontSize: '90%',
            },
            '& .value': {
                fontWeight: 'bold',
            },
        },
        //
        root: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.default,
        },
        dialogRoot: {
            backgroundColor: theme.palette.background.default,
            padding: '0 !important',
        },
        details: {
            // FIXME: proper height here ...
            // height: '65vh',
            height: 'calc(100vh - 152px)',
            padding: '10px 10px',
            marginRight: '6px',
            // overflow: 'auto',
            overflowX: 'hidden',
        },
        detailsWithoutFooter: {
            height: 'calc(100vh - 99px)',
        },
        patientInfoRow: {
            // width: "100%",
            fontSize: 20,
            // padding: 10,
            borderBottom: '1px solid ' + theme.palette.divider,
        },
        patientInfoLabel: {
            display: 'inline-block',
            padding: 10,
            verticalAlign: 'top',
        },
        patientInfo: {
            display: 'inline-block',
            verticalAlign: 'top',
            marginTop: 2,
            // marginLeft: 20,
            // textAlign: 'right',
            // float: 'right'
        },
        vtesModal: {
            top: '30px',
            position: 'absolute',
            background: '#535252',
            width: '80%',
            zIndex: 99,
            minHeight: '70%',
            overflow: 'auto',
            padding: '20px',
            margin: '10%',
            maxHeight: 500,
        },
        // PANELS ...
        mainPanel: {
            // padding: 10,
        },
        dnacprIcon: {
            border: '1px solid red',
            display: 'inline-flex',
            width: '28px',
            height: '28px',
            background: 'antiquewhite',
            borderRadius: '5px',
            animation: 'blink 1s',
            animationIterationCount: 'infinite',
            cursor: 'pointer',
        },
        dnacprInfoBlock: {
            border: '2px solid red',
            animation: 'blink 1s',
            animationIterationCount: 'infinite',
            borderRadius: '5px',
            background: '#ecacac',
            color: 'darkred',
            padding: '2px 3px',
            cursor: 'pointer',
            fontSize: '14px',
        },
        dnacprInline: {
            display: 'inline-flex',
            marginLeft: '4px',
        },
        addSpace: {
            paddingLeft: '4px',
            lineHeight: '28px',
        },
        dnacprRecSignature: {
            marginLeft: '10px',
            background: '#ffa500',
            padding: '3px 12px',
            color: 'white',
            border: '1px solid #e85b0f',
            borderRadius: '5px',
        },
        dnacprExpirationInfo: {
            marginLeft: '10px',
            background: '#ff5200',
            padding: '3px 12px',
            color: 'white',
            border: '1px solid #e80f0f',
            borderRadius: '5px',
        },
        iframe: {
            width: '100%',
            height: '100%',
        },

        singleIconFlagRef: {
            display: 'inline-block',
            backgroundColor: theme.palette.flags.singleIconFlag.default,
            textAlign: 'center',
            color: 'white',
            width: dynamicWidth,
            height: dynamicWidth,
            margin: '0 5px',
            border: '1px solid #414141',
            borderRadius: '4px',
            paddingTop: 7,
            '&.completed': {
                borderColor: '#000',
                color: '#000',
            },
        },
        singleIconFlag: {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            width: dynamicWidth,
            height: dynamicWidth,
            '&.padding': {
                padding: `${(dynamicWidth - 24) / 2}px 0`,
            },
            '&.active': {
                backgroundColor: theme.palette.flags.singleIconFlag.active,
                color: theme.palette.flags.singleIconFlag.activeColor,
            },
            '&.ice': {
                height: 35,
                width: 35,
                borderRadius: 4,
                backgroundColor: theme.palette.flags.singleIconFlag.ice,
                color: theme.palette.flags.singleIconFlag.iceColor,
                fontSize: 20,
                alignItems: 'center',
            },
            '&.none': {
                color: theme.palette.flags.singleIconFlag.noneColor,
            },
            '&.confirm': {
                color: theme.palette.flags.singleIconFlag.confirmColor,
            },
            '&.suspected': {
                color: theme.palette.flags.singleIconFlag.suspectedColor,
            },
            '&.sepsis': {
                color: '#dc4a5d',
            },
        },
        draftButton: {
            color: '#fff',
            border: '10px #FFBF00',
            borderStyle: 'solid none',
        },
        paedPaper: {
            display: 'grid',
            alignContent: 'start',
            gridGap: 16,
            padding: 10,
            marginLeft: 15,
            marginTop: 6,
            backgroundColor: theme.palette.background.paperDarker,
        },
        statusIcon: {
            display: 'inline-block',
            // fontSize: 12,
            backgroundColor: theme.palette.background.paper,
            fontWeight: 'bold',
            width: '100%',
            height: '100%',

            marginTop: '-15px',
            textAlign: 'center',
            paddingTop: 'auto',
            paddingBottom: 'auto',
            // "& svg": {cT
            //   transform: `scale(${iconWidth / 24})`,
            // },
        },
        flexContainer: {
            maxHeight: 'max-content',
            display: 'flex',
            flexDirection: 'row',
            // alignItems: 'center'
        },
        divRow: {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignItems: 'center',
        },
        paddingX: {
            paddingLeft: 10,
            paddingRight: 10,
        },
        customBackground: {
            backgroundColor: theme.palette.mode === 'light' ? '#eff1f3' : '#222425',
        },
        mainScreenContainer: {
            marginTop: 16,
            paddingRight: 10,
        },
        gridMainScreen: {
            display: 'grid',
            gap: 16,
            width: '100%',
            marginLeft: 16,
            marginTop: 12,
            height: 'auto',
        },
        reviewMainScreen: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            width: '100%',
            marginTop: 12,
            height: 'calc(100vh - 270px)',
            paddingLeft: 15,
        },
        topColumn: {
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            alignContent: 'flex-start',
            maxHeight: 'min-content',
            height: 'min-content',
        },
        visitBoxContainer: {
            paddingRight: 10,
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            alignContent: 'flex-start',
            justifyContent: 'space-between'            
        },
        visitBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: 35,
            padding: 10,
            borderRadius: 5,
            backgroundColor: theme.palette.designSystem.colors.green[700],
            fontSize: '120%',
            fontWeight: 700,
            color: '#ffffff',
        },
        spinner: {
            display: 'flex',
            alignItems: 'center',
        },
    };
});